module.exports = __webpack_public_path__ + "static/media/background-blobs.aca3d1ad.png";